export const inspirationData = [
    
    
    {
        name: 'Dobbelstenen',
        owner: 'Studio Tast',
        date:'1-5-2019',
        informationbold: 'Je kan dit programmatje bijvoorbeeld gebruiken om monopoly te spelen.',
        information:'Of andere bordspelletjes zoals ganzenborden mens erger je niet of muizenval',
    }
    ,
    {
        name: 'Dokter Bibber',
        owner: 'Studio Tast',
        date:'1-5-2019',
        informationbold: 'Opereer dokter bibber met de pijltjes toetsen van je laptop.',
        information:'Een grote tekening van een man die geopereerd moet worden',
    }
    ,
    {
        name: 'Doolhof',
        owner: 'Studio Tast',
        date:'1-5-2019',
        informationbold: 'Teken een doolhof met de goto en los hem daarna op met of de pijltjes toetsen of door coordinaten in te voeren.',
        information:'Om een goed doolhof te tekenen heb je een ingang en een uitgang nodig. De goto kan alleen maar doorlopende lijnen tekenen dus midden in het tekenen van het doolhof stopt de goto een paar seconden wanneer je hem even zelf naar het goede punt moet verplaatsen.',
    }
    ,
    {
        name: 'Flesje draaien',
        owner: 'Studio Tast',
        date:'1-5-2019',
        informationbold: 'Met dit programmatje kan je flesje draaien spelen in de klas.',
        information:'Je kan het ook als rad van fortuin gebruiken. of het een keuze laten maken wie bijvoorbeeld de tikker is bij tikkertje of de zoeker bij verstoppertje.',
    }
    ,
    {
        name: 'Spiraal of solide blok',
        owner: 'Studio Tast',
        date:'1-5-2019',
        informationbold: 'Je kan een blok tekenen door een dikke stift erin te doen en hem laten tekenen',
        information:'Of je laat hem een spiraal tekenen met een dun potlood. als je de groei grootte aanpast kun je het verschil tussen de lijnen groter of kleiner maken',
    }
    ,
    {
        name: 'Circkel',
        owner: 'Studio Tast',
        date:'1-5-2019',
        informationbold: 'Even klaar met alleen maar hoeken en schuine lijnen? met dit programma kan de GoTo een circkel tekenen',
        information:'In dit programmatje word met een wiskundige berekening uitgerekend hoe de goto met kleine x en y stapjes een circkel kan tekenen.',
    }
    ,
    {
        name: 'Piano',
        owner: 'Studio Tast',
        date:'1-5-2019',
        informationbold: 'Je kan de GoTo tekenrobot ook voor andere dingen gebruiken als alleen tekenen hij maakt namenlijk ook veel geluid.',
        information:'Met dit bestand kun je je asdf en wer of klikken op de toetsen gebruiken om de piano te besturen.',
    }
    ,
    {
        name: 'Liesje heeft een lammetje',
        owner: 'Studio Tast',
        date:'1-5-2019',
        informationbold: 'Je kan de GoTo tekenrobot ook voor andere dingen gebruiken als alleen tekenen hij maakt namenlijk ook veel geluid.',
        information:'In dit bestand staat de code die met het geluid van de GoTo het liedje liesje heeft een lammetje maakt.',
    }
    ,
    {
        name: 'Darth Vader',
        owner: 'Studio Tast',
        date:'17-5-2019',
        informationbold: 'Met dit bestand  kan de GoTo Darth Vader van StarWars uittekenen.',
        information:'Dit bestand is opgebouwd in blokken je hebt een blok met veel streepjes op een oppervlakte door deze af te wisselen kan je een plaatje namaken met een soort van pixels.',
    }
    ,
    {
        name: 'Stuur je eigen creatie in',
        owner: 'goto@studiotast.com',
        date:'',
        informationbold: 'Stuur jou eigen creatie in en misschien beland deze wel op onze inspiratie pagina!',
        information:'mail je project naar <a style="color:#E8308B;" href="mailto: goto@studiotast.com">goto@studiotast.com</a> met je naam, xml bestand, beschrijving en een foto van je werk.',
    }
    ,
];


// WEBPACK FOOTER //
// ./resources/assets/utilities/Inspiration.js